const handlebars__sidebarMenu = `
<nav class="menu menu-open" id="theMenu" style="position: relative; right: auto; width: auto">
    <div class="menu-wrap" style="position: relative; left: 0; width: auto">
        <h2 class="menu-close">{{translate 'TR_OPCIONES' ''}}</h2>

        {{#eachSorted world_tabs "sort"}}
            {{#if this.visible_in_menu}}
                {{#ifCond this.id '==' 1}}
                    <a id="{{this.world_tab_id}}" class="text-uppercase selected-tab">{{ this.name }}</a>
                {{/ifCond}}
                {{#ifCond this.id '==' 2}}
                    {{#if ../world_allow_challenges }}
                        <a id="{{this.world_tab_id}}" class="text-uppercase selected-tab">{{ this.name }}</a>
                    {{/if}}
                {{/ifCond}}
                {{#ifCond this.id '==' 3}}
                    {{#if ../is_show_ranking }}
                        <a id="{{this.world_tab_id}}" class="text-uppercase selected-tab">{{ this.name }}</a>
                    {{/if}}
                {{/ifCond}}
                {{#ifCond this.id '==' 4}}
                    <a id="{{this.world_tab_id}}" class="text-uppercase selected-tab">{{ this.name }}</a>
                {{/ifCond}}
                {{#ifCond this.id '==' 5}}
                    <a id="{{this.world_tab_id}}" class="text-uppercase selected-tab">{{ this.name }}</a>
                {{/ifCond}}
                {{#ifCond this.id '==' 6}}
                    <a href="#" id="{{this.world_tab_id}}" class="text-uppercase selected-tab" data-folder-id="{{this.folder_tab_id}}">{{ this.name }}</a>
                {{/ifCond}}
                {{#ifCond this.id '==' 19}}
                    <a href="#" id="{{this.world_tab_id}}" class="text-uppercase selected-tab">{{ this.name }}</a>
                {{/ifCond}}

                {{#if this.visible_in_web}}
                    {{#ifCond this.id '==' 7}}
                        <a href="#" id="{{this.world_tab_id}}" class="text-uppercase selected-tab">{{ this.name }}</a>
                    {{/ifCond}}

                    {{#ifCond this.id '==' 8}}
                        <a href="#" id="{{this.world_tab_id}}" class="text-uppercase selected-tab">{{ this.name }}</a>
                    {{/ifCond}}

                    {{#ifCond this.id '==' 9}}
                        <a href="#" id="{{this.world_tab_id}}" class="text-uppercase selected-tab">{{ this.name }}</a>
                    {{/ifCond}}

                    {{#ifCond this.id '==' 10}}
                        {{#unless is_lms }}
                            <a href="#" id="{{this.world_tab_id}}" class="text-uppercase selected-tab">{{ this.name }}</a>
                        {{/unless}}
                    {{/ifCond}}

                    {{#ifCond this.id '==' 11}}
                        <a href="#" id="{{this.world_tab_id}}" class="text-uppercase selected-tab">{{ this.name }}</a>
                    {{/ifCond}}

                    {{#ifCond this.id '==' 12}}
                        {{#if ../support_email }}
                            <a id="{{this.world_tab_id}}" href="mailto:{{../support_email}}" target="_blank" class="text-uppercase selected-tab">{{ this.name }}</a>
                        {{/if}}
                    {{/ifCond}}

                    {{#ifCond this.id '==' 13}}
                        <a href="#" id="{{this.world_tab_id}}" class="text-uppercase selected-tab">{{ this.name }}</a>
                    {{/ifCond}}

                    {{#ifCond this.id '==' 18}}
                        {{#if ../privacy_policy_enabled}}
                            <a href="#" id="{{this.world_tab_id}}" class="text-uppercase selected-tab">{{ this.name }}</a>
                        {{/if}}
                    {{/ifCond}}
                    {{#ifCond this.id '==' 17}}
                        {{#unless is_lms }}
                            <a href="#" id="{{this.world_tab_id}}" class="text-uppercase selected-tab logoutBtn">{{translate 'TR_DESCONECTAR' ''}}</a>
                        {{/unless}}
                    {{/ifCond}}
                    {{#ifCond this.id '==' 20}}
                            <a href="#" id="{{this.world_tab_id}}" class="text-uppercase selected-tab">{{ this.name }}</a>
                    {{/ifCond}}
                {{/if}}
            {{/if}}
        {{/eachSorted}}
    </div>
</nav>
  `;

class ReactController {
    static initializeReact(value) {
        // window.testHandleMenu({this: value});
    }

}